// Keep established EasyPeasy download URLs; all other books get an ID namespace.
export function publicationPaths(book){
  if(book.downloadBase && book.downloadStem) return {base:book.downloadBase,stem:book.downloadStem};
  const legacy=book.id.startsWith('easypeasy-');
  return {base:legacy?`downloads/${book.language}/`:`downloads/${book.id}/`,stem:legacy?'easypeasy':'book'};
}
